export const facebookUrl = 'https://www.facebook.com/panboxsweden/';
export const panBoxUrl = 'https://panbox.se/';
export const SNACKBAR_DURATION = 3500;
export const SEAMLESS_VIEW_ID = 'swedbank-pay-seamless-view-page';
